import { Loader2 } from 'lucide-react';
import { useTheme } from 'styled-components';

import { LoaderWrapper, Wrapper } from './styles';

interface LazyLoadingPageProps {
  height?: string;
}

const LazyLoadingPage = ({ height }: LazyLoadingPageProps) => {
  const theme = useTheme();

  return (
    <Wrapper height={height}>
      <LoaderWrapper>
        <Loader2 color={theme?.colors?.primary?.main || '#05b672'} size={40} />
      </LoaderWrapper>
    </Wrapper>
  );
};

export default LazyLoadingPage;
